import { ISyncProductList } from '../types';
import { Checkbox, Typography } from '@weareopenr/component-library';
import styles from '../SyncReportModal.module.scss';
import { SYNC_MESSAGE_TEXT } from 'src/constants';

export const SyncProductList = ({
  productListData,
  handleCheckedProduct,
  selectedProducts,
  showCheckbox,
  stepCount,
}: ISyncProductList) => {
  const noProductMessage = `No ${SYNC_MESSAGE_TEXT[stepCount]} products`;

  return (
    <ul className={styles['list-container']}>
      {productListData.length === 0 ? (
        <li className={styles['list-item']}>{noProductMessage}</li>
      ) : (
        <>
          {productListData.map(({ id, name, ranges }) => {
            const rangeNames = ranges.map((range) => range.name);

            return (
              <li className={styles['list-item']} key={id}>
                <div className={styles['label-container']}>
                  <Typography size="medium" weight="regular">
                    {name}
                  </Typography>

                  {rangeNames.length > 0 && (
                    <Typography size="xsmall">
                      <span title={rangeNames.join('\r\n')}>{rangeNames.join(', ')}</span>
                    </Typography>
                  )}
                </div>
                {showCheckbox && (
                  <div>
                    <Checkbox
                      label={''}
                      name="productItem"
                      onChange={(e) => handleCheckedProduct(e, id)}
                      checked={selectedProducts.includes(id)}
                    />
                  </div>
                )}
              </li>
            );
          })}
        </>
      )}
    </ul>
  );
};
